import { render, staticRenderFns } from "./AdminInputMultiselect.vue?vue&type=template&id=3075a9c4&"
import script from "./AdminInputMultiselect.vue?vue&type=script&lang=js&"
export * from "./AdminInputMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./AdminInputMultiselect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})
